import { render } from "./SidenavList.vue?vue&type=template&id=45ef3700"
import script from "./SidenavList.vue?vue&type=script&lang=js"
export * from "./SidenavList.vue?vue&type=script&lang=js"

import "./SidenavList.vue?vue&type=style&index=0&id=45ef3700&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__